<template>
  <div class="app-container paiwei singe-content">
    <Headers></Headers>
    <Header></Header>

      <div class="" v-if="gameState === 'matching'">
        <div class="fs50 w-title ac" style="margin-top: -110px;margin-bottom: 60px;">{{$t('FastChallenge')}}</div>
        <div class="ac mt30">
          <img src="../../static/images/fast-img.png"/>
        </div>
      </div>
    <div class="wait-bg mt30 ac" v-if="gameState === 'matching'">
      <div class="title fs33" style="padding-top:20px">{{$t('question_ready')}}...</div>
      <div>{{$t('Waiting')}}: {{ waitTime }}s</div>
    </div>

    <!-- 对战面板 -->
    <div class="battle-panel" v-if="gameState === 'playing'">
      <div class="fs50 w-title ac" style="margin-top: -110px;margin-bottom: 60px;">{{$t('FastChallenge')}}</div>
      <!-- 新增倒计时特效 -->
      <div v-if="countdownVisible" class="countdown-overlay">
        <div class="countdown-number" :key="countdownNumber">{{ countdownNumber }}</div>
      </div>

      <div class="score-board">
        <div class="bar bar-left">
          <div class=""><span class="span" :style="{ width: (scores.your_score_rate * 100) + '%' }"></span></div>
          <div class="player-card">
            <div class="player-img">
              <img class="avatar" :src="playerInfo.avatar || '../../static/images/default-avatar.png'">
            </div>
            <div class="question-meta">
               {{ your_correct_num }}/{{ totalQuestions }}{{$t('Correct')}}!
             </div>
             <div class="g-score"><img src="../../static/images/hd-ic3.png">+{{ scores.player }}</div>
          </div>
        </div>
      </div>

      <!-- 题目区域 -->
      <div class="question-box" v-if="!countdownVisible">

        <div class="question-c">
          <img class="w100 qs-img" :src="currentImg">
          <h3 class="question-title" id="questionTitle">{{ currentQuestion }}</h3>
          <!-- 圆形倒计时（宽度140px） -->
          <div class="circular-c">
            <div class="circular-timer">
              <svg width="90" height="90" viewBox="0 0 90 90">
                <circle class="bg" cx="45" cy="45" r="40"></circle>
                <circle
                  class="progress"
                  cx="45"
                  cy="45"
                  r="40"
                  stroke-width="8"
                  :stroke-dasharray="circumference"
                  :stroke-dashoffset="circumference * (1 - timeLeft / timeTotal)"
                ></circle>
              </svg>
              <div class="time-text">{{ timeLeft }}</div>
            </div>
          </div>
        </div>
        <div class="options disflex">
          <button
            v-for="(option, key) in currentOptions"
            :key="key"
            class="option-btn"
            :class="{
              ' btn-green': option=='YES',
              ' btn-red': option=='NO',
              ' correct': selectedAnswer==key,
            }"
            :disabled="answerRevealed || isAnswerSubmitted"
            @click="selectAnswer(key)"
          >
            <span>
              <img v-if="option=='YES'" src="../../static/images/correct.png">
              <img v-if="option=='NO'" src="../../static/images/error.png">
              {{ key }}.{{ option }}
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- 游戏结束面板 -->
    <div class="modal " v-if="gameState === 'ended'">
      <div class="modal-bg"></div>
      <div class="modal-content">
        <div class="match-panel redeem-modal">
          <div class="over-c">
            <div class="md-title">{{$t('Congratulations')}}</div>
            <div class="image ac">
              <img class="img1" src="../../static/images/hd-ic3.png"> {{ scores.player }}
              <img class="img1" src="../../static/images/hd-ic2.png"> x 1
            </div>
            <div class="btn-bottom disflex mt50">
              <a @click="getToNav()" class="btn btn-none" style="border-radius: 100px;">{{$t('BackToHome')}}</a>
              <button class="btn btn-green" @click="startMatch" style="border-radius: 100px;font-size:24px">{{$t('PlayAgain')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 购买机会 -->
    <Dialog ref="otpDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
      <div class="" slot="mdBox">
        <div class="otp-title" >{{$t('ChanceEnough')}}</div>
        <div class="otp-modal disflex ac">
          <div>
            <img class="by-img" src="../../static/images/buy-img.png">
            <div class="otp-font">
              {{$t('BuyChancesC')}}
            </div>
            <div class="mt10 disflex">
              <button class="btn btn-none" style="border: 2px solid #fff;color:#fff;width: auto;min-width: 250px;" @click="cancelOtpDialog">{{$t('Later')}}</button>
              <button class="btn btn-blue" style="width: auto;min-width: 250px;" @click="getSubmit">{{$t('BuyMore')}}</button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>

  </div>
</template>

<script>
import Headers from '../components/Header'
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'
import AudioService from '@/services/AudioService'
import '../../static/js/howler.min.js'
export default {
  components:{
    Header,Dialog,Headers
  },
  name: 'KnowledgeBattle',
  data() {
    return {
      ws: null,
      match_type:"fast",
      connectionStatus: 'Not connected',
      gameState: 'connecting', // connecting, matching, playing, ended
      playerInfo: {
        user_id: null,
        nickname: '',
        avatar: '',
        level: null
      },
      roomId: null,
      matchLevelRange: '0',
      waitTime: 0,
      matchTimer: null,
      currentQuestionIndex: 0,
      totalQuestions: 0,
      your_correct_num: 0,
      currentQuestion: '',
      currentOptions: {},
      correctAnswer: null,
      selectedAnswer: null,
      answerRevealed: false,
      isAnswerSubmitted: false,
      scores: {
        player: 0
      },
      timeLeft: 0,
      timeTotal: 10,
      timerInterval: null,
      circumference: 2 * Math.PI * 40, // 圆形进度条周长 (2πr)
      gameResult: null, // win, lose, draw

      // 新增倒计时相关数据
      countdownVisible: false,
      countdownNumber: 3,
      //音效
      audioService: AudioService,
      isBgmPlaying: false,
      currentImg:'',
      sounds: {
        correct: null,
        error: null,
        countdown: null,
        over:null
      },
    }
  },
  created() {
    this.initHowler()
    this.connect()
  },
  mounted(){
    // this.audioService.init();
    // this.startBackgroundMusic();
  },
  beforeDestroy() {
    this.disconnect();
    // this.stopBackgroundMusic();
  },
  methods: {
    initHowler() {
      Howler.autoUnlock = true
      Howler.mobileAutoEnable = true
      this.sounds.correct = new Howl({
        src: ['../../static/music/answer_correct.mp3'],
        volume: 1.0,
        preload: true
      })
      this.sounds.error = new Howl({
        src: ['.../../static/music/answer_error.mp3'],
        volume: 1.0,
        preload: true,
      })
      this.sounds.countdown = new Howl({
        src: ['.../../static/music/countdown.mp3'],
        volume: 1.0,
        preload: true,
      })
      this.sounds.over = new Howl({
        src: ['.../../static/music/battle_win.mp3'],
        volume: 1.0,
        preload: true,
      })
    },
    getToNav(url){
      this.$router.push({path:'/'});
    },
    connect() {
      this.disconnect();
      this.ws = new WebSocket('wss://demo-api.studygo.asia/ws');

      this.ws.onopen = () => {
        this.connectionStatus = 'WebSocket connected';
        this.ws.send(JSON.stringify({
          match_type: this.match_type,
          action: 'login',
          mobile: localStorage.getItem('mobile'),
        }));
      };

      this.ws.onmessage = (e) => {
        const data = JSON.parse(e.data);
        this.handleMessage(data);
      };

      this.ws.onerror = (error) => {
        console.error('WebSocket error:', error);
        this.connectionStatus = 'WebSocket error';
      };

      this.ws.onclose = () => {
        console.log('WebSocket closed');
        this.connectionStatus = 'WebSocket closed';
      };
    },

    disconnect() {
      if (this.ws) {
        this.ws.close();
      }
      this.clearTimers();
    },

    clearTimers() {
      if (this.matchTimer) {
        clearInterval(this.matchTimer);
        this.matchTimer = null;
      }
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },

    handleMessage(data) {
      if (data.match_type !== this.match_type){
        return;
      }
      switch(data.action) {
        case 'login_success':
          this.handleLoginSuccess(data);
          break;
        case 'chance_error':
          this.handleChanceError(data);
          break;
        case 'match_waiting':
          this.showMatchPanel(data);
          break;
        case 'enter_room':
          this.startGame(data);
          break;
        case 'new_question':
          this.showQuestion(data);
          break;
        case 'answer_result':
          this.handleAnswerResult(data);
          break;
        case 'game_over':
          this.endGame(data);
          break;
        case 'timeout':
          this.playSound('basic.wrong')
          break;
        //断开重连
        case 'reconnect_room':
          this.handleReconnect(data);
          break;
        case 'error':
          console.log(data.message);
          break;
      }
    },

    handleLoginSuccess(data) {
      console.log(data)
      this.playerInfo = {
        user_id: data.data.user_id,
        nickname: data.data.nickname,
        avatar: data.data.avatar,
        level: data.data.level
      };
      this.startMatch();
    },

    startMatch() {
      this.clearTimers();
      this.gameState = 'matching';
      this.waitTime = 0;
      this.scores = { player: 0 };
      this.matchTimer = setInterval(() => {
        this.waitTime++;
      }, 1000);

      this.ws.send(JSON.stringify({
        match_type: this.match_type,
        action: 'start_match',
      }));
    },

    showMatchPanel(data) {
      this.matchLevelRange = data.data.level;
    },

    startGame(data) {
      this.clearTimers();

      this.startCountDown();

      this.timeTotal = 3;
      this.timeLeft = 3;
      this.startTimer();
      this.gameState = 'playing';
      this.roomId = data.room_id;
      // 确定玩家和对手
      const player1 = data.opponent.player1;
      this.playerInfo = {
        user_id: player1.user_id,
        nickname: player1.nickname,
        avatar: player1.avatar,
        level: player1.level
      };
    },

    showQuestion(data) {
      this.currentQuestionIndex = data.question_no;
      this.totalQuestions = data.question_count;
      this.currentQuestion = data.question;
      this.currentImg = data.image;
      this.currentOptions = data.options;
      this.timeTotal = data.timeout || 10;
      this.timeLeft = this.timeTotal;
      this.answerRevealed = false;
      this.isAnswerSubmitted = false;
      this.selectedAnswer = null;

      this.startTimer();
    },

    startTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }

      this.timerInterval = setInterval(() => {
        this.timeLeft--;

        if (this.timeLeft <= 0) {
          clearInterval(this.timerInterval);
          this.disableOptions();
        }
      }, 1000);
    },

    selectAnswer(answerKey) {
      this.selectedAnswer = answerKey;
      this.isAnswerSubmitted = true;
      this.ws.send(JSON.stringify({
        match_type: this.match_type,
        action: 'submit_answer',
        room_id: this.roomId,
        question_no: this.currentQuestionIndex,
        answer: answerKey,
      }));
    },

    handleAnswerResult(data) {
      if (data.user_id === this.playerInfo.user_id) {
        this.scores.player = data.your_score;
        this.scores.your_score_rate = data.your_score_rate;
        this.your_correct_num = data.your_correct_num;
        this.correctAnswer = data.correct_answer;
        this.answerRevealed = true;
        if (data.is_correct){
          //答对
          this.playSound('basic.correct')
        }else{
          //答错
          this.playSound('basic.wrong')
        }
      }
    },

    disableOptions() {
      this.isAnswerSubmitted = true;
    },

    endGame(data) {
      this.clearQuestion();
      this.clearTimers();
      this.gameState = 'ended';

      const results = data.results;
      const maxScore = Math.max(...results.map(player => player.score));
      const winners = results.filter(player => player.score === maxScore);
      const currentPlayer = results.find(player => player.user_id === this.playerInfo.user_id);

      if (!currentPlayer) {
        this.gameResult = null;
      } else if (currentPlayer.score === maxScore) {
        this.gameResult = winners.length > 1 ? 'draw' : 'win';
        this.playSound('sfx.win')
      } else {
        this.gameResult = 'lose';
        this.gameResult = 'lose';
      }

      this.scores.player = currentPlayer.score;

      //alert(`${this.gameResult === 'win' ? '胜利' : this.gameResult === 'lose' ? '失败' : '平局'}\n你的得分：${this.scores.player}`);
    },
    clearQuestion(){
      this.currentQuestionIndex = 0;
      this.totalQuestions = 0;
      this.currentQuestion = "";
      this.currentOptions = {};
      this.currentImg = "";
      this.timeTotal = 10;
      this.timeLeft = 0;
      this.answerRevealed = false;
      this.isAnswerSubmitted = false;
      this.selectedAnswer = null;
      this.your_correct_num = 0;
    },
    //恢复链接
    handleReconnect(data){
      this.roomId = data.room_id;
      //恢复玩家信息
      this.playerInfo = {
        user_id: data.playerInfo.user_id,
        nickname: data.playerInfo.nickname,
        avatar: data.playerInfo.avatar,
        level: data.playerInfo.level
      };

      //恢复分数信息
      this.scores.player = data.opponent_score.your_score;
      this.scores.opponent = data.opponent_score.opponent_score;
      this.scores.your_score_rate = data.opponent_score.your_score_rate;
      this.scores.opponent_score_rate = data.opponent_score.opponent_score_rate;
      this.your_correct_num = data.opponent_score.your_correct_num;
      //恢复题目
      this.currentQuestionIndex = data.question_data.question_no;
      this.totalQuestions = data.question_data.question_count;
      this.currentQuestion = data.question_data.question;
      this.currentImg = data.question_data.image;
      this.currentOptions = data.question_data.options;
      this.timeTotal = data.question_data.timeout || 10;
      this.timeLeft = this.timeTotal;
      this.startTimer();
      //恢复答题结果
      this.isAnswerSubmitted = data.current_question_result.isAnswerSubmitted;
      this.selectedAnswer = data.current_question_result.user_answer;
      if (data.current_question_result.user_answer){
        this.correctAnswer = data.current_question_result.correctAnswer;
        this.answerRevealed = true;
      }
      this.gameState = 'playing';
    },

    handleChanceError(data){
      let that =this;
      that.gameState = 'connecting'
      that.$refs.otpDialog.showMaskFun();
    },
    cancelOtpDialog(){
      this.$refs.otpDialog.closeMask();
      this.$router.push({path:'/'});
    },
    getSubmit(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/index/buy',null,r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          if (r.code == 1){
            that.$refs.otpDialog.closeMask();
            that.$utils.alertText(r.msg,80, 800);
            that.startMatch();
          }else{
            that.$utils.alertText(r.msg,80, 3000);
          }
        });
      })
    },
    startCountDown(){
      // 启动3秒倒计时特效
      this.countdownVisible = true;
      this.countdownNumber = 3;
      this.playSound('sfx.countdown')
      const countdownInterval = setInterval(() => {
        this.countdownNumber -= 1;
        if (this.countdownNumber <= 0) {
          clearInterval(countdownInterval);
          this.countdownVisible = false;
        }
      }, 1000);
    },
    playSound(soundName) {
      if (soundName == 'sfx.countdown'){
        this.play_countdown();
      }else if(soundName == 'basic.wrong'){
        this.play_error();
      }else if(soundName == 'basic.correct'){
        this.play_correct();
      }else {
        this.play_over();
      }
      // this.audioService.play(soundName)
      //   .then(() => console.log(`${soundName} 播放成功`))
      //   .catch(e => console.error(`${soundName} 播放失败:`, e));
    },
    startBackgroundMusic() {
      // 如果正在播放，则不再重复播放
      if (this.isBgmPlaying) {
        console.log('背景音乐已在播放中');
        return;
      }
      this.audioService.play('bgm.main', { loop: true })
        .then(() => {
          this.isBgmPlaying = true;
          console.log('背景音乐开始播放');
        })
        .catch(e => {
          console.error('背景音乐播放失败:', e);
          this.isBgmPlaying = false;
        });
    },
    stopBackgroundMusic() {
      this.audioService.stopBackground();
      console.log('背景音乐已停止');
    },
    play_correct(){
      this.sounds.correct.play()
    },
    play_error(){
      this.sounds.error.play()
    },
    play_countdown(){
      this.sounds.countdown.play()
    },
    play_over(){
      this.sounds.over.play()
    },
  }
}
</script>

<style scoped>
/* 新增倒计时样式 */
.countdown-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  pointer-events: none;
}

.countdown-number {
  font-size: 200px;
  color: #fff;
  text-shadow: 0 0 20px rgb(255, 255, 255);
  animation: countdownPop 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes countdownPop {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/fast.vue